import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { PageHeader } from "../components/ui";

const jobOpenings = [
  {
    title: "Senior Digital IC Design Engineer",
    location: "Bangalore, India",
    type: "Full-time",
    description:
      "Lead the design and development of complex digital blocks for next-generation AI and high-performance computing chips. Requires expertise in RTL design, synthesis, and timing closure.",
  },
  {
    title: "Physical Design Engineer",
    location: "Smriti Nagar, India",
    type: "Full-time",
    description:
      "Focus on physical implementation, including floor planning, placement, and routing for advanced process nodes. Knowledge of static timing analysis (STA) is essential.",
  },
  {
    title: "Verification Engineer (UVM)",
    location: "Smriti Nagar, India",
    type: "Full-time",
    description:
      "Develop and execute verification plans for complex SoC and IP designs using UVM methodology. Strong debugging skills and a solid understanding of Verilog/SystemVerilog are a must.",
  },
];

const DESCRIPTION =
  "Explore semiconductor roles across RTL, DV, DFT, physical design, STA, FPGA, validation and embedded systems with Chiparama.";

export default function CareersPage() {
  return (
    <>
      <Helmet>
        <title>Careers at Chiparama | Semiconductor Engineering Jobs</title>
        <meta name="description" content={DESCRIPTION} />
        <link rel="canonical" href="https://chiparama.com/careers" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Careers at Chiparama | Semiconductor Engineering Jobs" />
        <meta property="og:description" content={DESCRIPTION} />
        <meta property="og:url" content="https://chiparama.com/careers" />
        <meta property="og:image" content="https://chiparama.com/chiparamalogo.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Careers at Chiparama | Semiconductor Engineering Jobs" />
        <meta name="twitter:description" content={DESCRIPTION} />
        <meta name="twitter:image" content="https://chiparama.com/chiparamalogo.jpg" />
      </Helmet>

      <PageHeader eyebrow="Careers" title="Build semiconductor systems that matter.">
        Chiparama works with engineers across RTL, DV, DFT, physical design, STA, FPGA, silicon
        validation and embedded systems. Explore current roles or join our specialist network for
        future programs that match your domain depth.
      </PageHeader>

      <section className="section bg-white">
        <div className="container-x max-w-4xl">
          <h2 className="mb-8 text-2xl font-semibold text-ink">Open roles</h2>
          <ul className="divide-y divide-line border-y border-line">
            {jobOpenings.map((job) => (
              <li key={job.title} className="flex flex-col gap-5 py-8 md:flex-row md:items-start md:justify-between">
                <div className="max-w-2xl">
                  <h3 className="text-xl font-semibold text-ink">{job.title}</h3>
                  <p className="mt-1.5 font-mono text-xs uppercase tracking-wider text-slate-500">
                    {job.location} · {job.type}
                  </p>
                  <p className="mt-4 leading-relaxed text-slate-600">{job.description}</p>
                </div>
                <a
                  className="btn-secondary shrink-0"
                  href={`mailto:careers@chiparama.com?subject=${encodeURIComponent("Application: " + job.title)}`}
                >
                  Apply by email
                </a>
              </li>
            ))}
          </ul>

          <div className="mt-14 rounded-2xl bg-paper p-8 md:p-10">
            <h3 className="text-xl font-semibold text-ink">Don't see a role for you?</h3>
            <p className="mt-3 max-w-2xl leading-relaxed text-slate-600">
              We are always looking for passionate and talented engineers. Send your resume and tell us
              how you can contribute, or join the Candidate Hub to hear about new programs first.
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <a className="btn-primary" href="mailto:careers@chiparama.com?subject=General%20application">
                Send a general application
              </a>
              <Link to="/candidates" className="btn-secondary">Open Candidate Hub</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
